import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoadingService } from '../../services/LoadingService';
import { Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-loading-indicator',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="overlay" role="status" aria-live="polite" *ngIf="isLoading$ | async">
      <div class="panel">
        <div class="spinner" aria-hidden="true"></div>
        <p class="message">
          <span class="sr-only">Status:</span>
          {{ loadingMessage }}
        </p>
      </div>
    </div>
  `,
  styleUrls: ['./loading-indicator.component.css']
})
export class LoadingIndicatorComponent {
  isLoading$: Observable<boolean>;
  loadingMessage = 'Seite wird geladen…';

  constructor(private loading: LoadingService, private router: Router) {
    this.isLoading$ = this.loading.isLoading$;

    // Update message based on navigation
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loadingMessage = 'Seite wird geladen…';
      }
    });
  }
}

